export const splitArray = <T>(items: T[], size: number): T[][] => {
	const result: T[][] = [];

	for (let i = 0; i < items.length; i += size) {
		result.push(items.slice(i, i + size));
	}

	return result;
};
